(() => {
  const bar = document.querySelector('[data-shop-switcher]');
  const dialog = document.getElementById('SkrStudioComingSoon');
  if (!bar || !dialog) return;
  const trigger = bar.querySelector('[data-switcher-studio]');
  const electronics = bar.querySelector('[data-switcher-electronics]');
  if (bar.dataset.previewTheme) {
    const url = new URL(electronics.href, document.baseURI);
    url.searchParams.set('preview_theme_id', bar.dataset.previewTheme);
    url.searchParams.set('pb', '0');
    electronics.href = url.href;
    const preservePreview = () => {
      if (!/^https?:$/.test(location.protocol)) return;
      const current = new URL(location.href);
      current.searchParams.set('preview_theme_id', bar.dataset.previewTheme);
      history.replaceState(null, '', current.pathname + current.search + current.hash);
    };
    preservePreview();
    if (document.readyState !== 'complete') addEventListener('load', preservePreview, { once: true });
  }
  if (typeof dialog.showModal !== 'function') return;
  trigger.addEventListener('click', event => {
    event.preventDefault();
    if (!dialog.open) dialog.showModal();
  });
  dialog.querySelectorAll('[data-switcher-close]').forEach(button => {
    button.addEventListener('click', () => dialog.close());
  });
  dialog.addEventListener('close', () => trigger.focus({ preventScroll: true }));
})();
